import { TxpOptionState } from './schema/TxpOptionState';
import { createStore } from 'satcheljs';
import '../mutators/updateTxpFlagV2';

const defaultStore = {
    CreateEventsFromEmailAsPrivate: null,
    IsEventsFromEmailEnabled: null,
    EventsFromEmailEnabled: null,
    Events: {
        DiningEventsFromEmailEnabled: null,
        EntertainmentEventsFromEmailEnabled: null,
        FlightEventsFromEmailEnabled: null,
        HotelEventsFromEmailEnabled: null,
        InvoiceEventsFromEmailEnabled: null,
        PackageDeliveryEventsFromEmailEnabled: null,
        RentalCarEventsFromEmailEnabled: null,
        ServiceAppointmentEventsFromEmailEnabled: null,
    },
    EntityTypeProcessorLevelSettings: {
        FlightReservation: null,
        FoodEstablishmentReservation: null,
        LodgingReservation: null,
        RentalCarReservation: null,
        ParcelDelivery: null,
        EventReservation: null,
        Invoice: null,
        ServiceReservation: null,
    },
};

export const getStore = createStore<TxpOptionState>('txpOption', defaultStore);
export default getStore;
